import React, { useEffect, useState } from 'react';
import MainPrivateLayout from '../../../config/MainPrivateLayout';
import {
	Label,
	FormGroup, 
	Row,
	Card,
	Col,
	Badge,
	Button,
	InputGroup,
	Input,
	InputGroupAddon,
	InputGroupText,
} from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Moment from 'react-moment';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import { getVentas } from '../../../store/action-creators/ProfilesActions';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { BsSearch } from 'react-icons/bs';
import { animateScroll as scroll } from 'react-scroll';
import { verifyRoles } from '../../../functions/roles';


const Ventas = () => {

	const dispatch = useDispatch();
	const { t } = useTranslation();
	const history = useHistory();
	const user = useSelector((store) => store.user.user);
	const savedToken = sessionStorage.getItem('token');		
	const [sectionRegistros, setSectionRegistros] = useState(true);	
	const [userSearched, setUserSearched] = useState("");		
	const [salesList, setSalesList] = useState([]);
	const [totalSales, setTotalSales] = useState(0);
	const [rolesHabilitado, setRolesHabilitado] = useState([15]);	
		

	useEffect(() => {
		
		let data = Object.assign({}, { token: savedToken });
		dispatch(getVentas(data))
			.then((res) => {				

				setSalesList(res.payload.salesList);
				setTotalSales(res.payload.totalSales);

			})
			.catch((error) => {
				console.log(error);
			});
		
	}, []);


	return (
		<MainPrivateLayout>

			{
				verifyRoles(user.roles,rolesHabilitado) ?

					<div className="page-content-container section-profiles-vendedores-ventas">

						<span className="page-title">Mis ventas</span>

						<Card className="admin-main-card">

							{sectionRegistros ? (
								<div className="registros">
									
									<div className="sales">								
										<div className="header">
											<Row>
												<Col sm={8}>
													<p className="title">Total = {totalSales} GBM</p>
												</Col>
												<Col sm={4}>
													<InputGroup>
														<InputGroupAddon addonType="prepend" className="prepend">
															<InputGroupText>
																<BsSearch />
															</InputGroupText>
														</InputGroupAddon>
														<Input
															value={userSearched}
															placeholder='Buscar usuario'
															onChange={(event) => setUserSearched(event.target.value)}
															autoComplete="new-password"
														/>
													</InputGroup>
												</Col>
											</Row>
											<hr />
										</div>

										<div className="sales-list list">
											<Table className="table">
												<Thead>
													<Tr>											
														<Th>Fecha</Th>																								
														<Th>Código</Th>
														<Th>Cantidad</Th>
														<Th>Precio (GBM)</Th>
														<Th>Detalle</Th>
													</Tr>
												</Thead>
												<Tbody>
													{salesList.length > 0 ?
														salesList.map((sale, index) => {
															
															if (sale.usuario == userSearched || userSearched === ''){														
																return (	
																	<Tr>														
																		<Td>
																			<Moment format="YYYY-MM-DD" utc>
																				{sale.created_at}
																			</Moment>
																		</Td>																
																		<Td>{sale.code}</Td>
																		<Td>{sale.value} GBM</Td>
																		<Td>u$ {sale.gbmusd}</Td>
																		<Td>
																			<a href={sale.tx_url} target="_blank">
																				detalle
																			</a>
																		</Td>
																	</Tr>
																);
															}
																
														  })
														: null
													}
												</Tbody>
											</Table>
										</div>						
									</div>
									
								</div>
							) : null}
							
						</Card>
					</div>
				: null
			}
		</MainPrivateLayout>
	);
};

export default Ventas;
